'use client'

import { useBorderColor } from '../../../hooks/useBorderColor'

interface QuestionTextProps {
  value: string | null
  onChange: (value: string) => void
  disabled: boolean
}

export function QuestionText({ value, onChange, disabled }: QuestionTextProps) {
  const { borderColor } = useBorderColor()

  return (
    <div className="w-full">
      <textarea
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder="Insira a resposta aqui"
        className={`
          w-full border-2 rounded-xl bg-white text-gray-800 p-4
          resize-none transition-colors
          ${borderColor}
          ${
            disabled
              ? 'opacity-50 cursor-not-allowed'
              : 'focus:border-primary focus:outline-none'
          }
        `}
        rows={4}
        disabled={disabled}
      />
    </div>
  )
}
